import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=6291a54a&scoped=true"
import script from "./Insurance.vue?vue&type=script&lang=js"
export * from "./Insurance.vue?vue&type=script&lang=js"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=6291a54a&prod&lang=scss"
import style1 from "./Insurance.vue?vue&type=style&index=1&id=6291a54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6291a54a",
  null
  
)

export default component.exports